export const CONFIRM_DIALOG_TYPES = {
  DISCARD: "discard",
  DELETE: "delete",
  SAVE: "save",
  CROSS: "cross",   
  EDIT: "edit",     
};

export const CONFIRM_DIALOG_MODELS = {
  discard: {
    icon: "warning",
    title: "Discard Changes?",
    message: "You have unsaved changes. If you leave now, your edits will be lost.",
    cancelLabel: "Continue editing",
    confirmLabel: "Discard",
    confirmTone: "primary",
  },
  delete: {
    icon: "delete",
    title: "Confirm Delete",
    message: "This card contains data. Are you sure you want to delete it?",
    cancelLabel: "Cancel",
    confirmLabel: "Delete",
    confirmTone: "danger",
  },
  
  cross: {
    icon: "warning",
    title: "Leave Without Saving?",
    message: "You have unsaved changes. If you leave now, your edits will be lost.",
    cancelLabel: "Stay",
    confirmLabel: "Leave",
    confirmTone: "danger",
  },
  
  edit: {
    icon: "warning",
    title: "Edit Warranty Card?",
    message: [
      "You are about to edit an existing warranty card.",
      "Any changes will need to be saved manually.",
    ],
    cancelLabel: "Cancel",
    confirmLabel: "Edit",
    confirmTone: "primary",
  },
  save: {
    icon: "warning",
    title: "Save Confirmation",
    message: [
      "Imported data has already been removed after printing.",
      "Only the original saved data will be updated.",
      "Do you want to continue saving?",
    ],
    cancelLabel: "Cancel",
    confirmLabel: "Continue Save",
    confirmTone: "primary",
    emphasizeLastLine: true,
  },
};

export const getConfirmDialogModel = (type, overrides = {}) => {
  const base = CONFIRM_DIALOG_MODELS[type];
  if (!base) {
    throw new Error(`Unknown confirm dialog type: ${type}`);
  }
  return { ...base, ...overrides };
};